import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, useToast} from "@chakra-ui/react";
import {useStoreProfile} from "../../../store";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useAward} from "../../../api/awards";

const AwardSheet = styled(({className, id, type, onClose}) => {

    const [confirmStage, setConfirmStage] = useState(false);

    const {available_awards} = useStoreProfile();

    const toast = useToast();
    const {error, feedbackCh} = useFeedback();
    const award = useAward(feedbackCh);

    const handleContinue = async () => {
        if (available_awards > 0) {
            if (confirmStage) {
                onClose();
                await award(id, type);
                toast({
                    title: `Successfully awarded!`,
                    status: 'success',
                    isClosable: true,
                })
            } else {
                setConfirmStage(true);
            }
        }
    }

    return (
        <div className={className}>

            <Header>
                <Title>{confirmStage ? 'Confirm' : 'Give'} Award</Title>
            </Header>

            {confirmStage ?
                <>
                    <p>Giving an award will use 1 award credit, which cannot be refunded.</p>
                </>
                :
                <>
                    <p style={{marginBottom: 24}}>
                        Awarding a post will help it attract more attention, and will grant the author a week of Pro.
                    </p>
                    <h2>
                        Award Credits
                    </h2>
                    <p>
                        {available_awards === 0 ?
                            "You don't have any award credits."
                            :
                            `${available_awards}`
                        }
                    </p>
                </>}

            <Button variant={'grey'} style={{width: '100%', marginTop: '24px'}} onClick={handleContinue}>
                {available_awards === 0 ? 'Close' : 'Give Award'}
            </Button>

        </div>
    );
}
)`
p {
    font-size: 17px;
}
h2 {
    font-size: 18px !important;
}
`;

export default AwardSheet;
